/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Box from '@mui/material/Box';

// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2017/11/measurecamp-sydney-2017-review/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2017/11/measurecamp-sydney-2017-review/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2017/11/measurecamp-sydney-2017-review/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Measure Camp Sydney 2017 Review - Tribalism",
  date: "2017-11-07",
  summary: "We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. This blog speaks a bit about our experience at Measure Camp Sydney 2017!",
  image: "/img/posts/2017-11-07-measurecamp-sydney-2017-review/1.webp",
  url: "https://www.tribalism.com.au/blog-post/2017/11/measurecamp-sydney-2017-review",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Measure Camp Sydney 2017 Review - Tribalism"
        image="/img/posts/2017-11-07-measurecamp-sydney-2017-review/1.webp"
        url="https://www.tribalism.com.au/blog-post/2017/11/measurecamp-sydney-2017-review"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. This blog speaks a bit about our experience at Measure Camp Sydney 2017 !"

        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2017-11-07-measurecamp-sydney-2017-review/1.webp" filter="dark" small >
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <Box 
                sx={{
                  '& h1': {
                    fontSize: {
                      xs: '2rem',
                      sm: '2.5rem',
                      md: '3rem',
                      lg: '4rem',
                      xl: '5rem'
                    }
                  }
                }}
              >
                <h1 className={classes.title}>
                  Measurecamp Sydney 2017 - Review
                </h1>
              </Box>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>

      <Footer
        
      />
    </div>
  );
}
